export const ORDER_STATUS = {
  WAIT_PAY: { value: 1, name: "待支付" },
  WAIT_ASSIGN: { value: 2, name: "待指派" },
  RECEIVING_ORDER: { value: 2.1, name: "接单中" },
  WAIT_APPOINTMENT: { value: 3, name: "待预约" },
  WAIT_PICK_UP: { value: 4, name: "待提货" },
  WAIT_INSTALL: { value: 5, name: "待上门" },
  WAIT_COMPLETE: { value: 6, name: "待完工" },
  WAIT_VERIF: { value: 7, name: "待核销" },
  WAIT_ACCEPT: { value: 8, name: "待验收" },
  SUCCESS: { value: 9, name: "订单完成" },
  UNSUCCESS: { value: 35, name: "订单未完成" },
  REFUND: { value: 10, name: "订单退款" },
  ABNORMAL: { value: 11, name: "订单异常" },
  DEAL: { value: 12, name: "交易完成" },
  CLOSE: { value: 15, name: "订单关闭" },
  EVALUATED: { value: 16, name: "已评价" },
  WAIT: { value: 17, name: "审核待处理" },
  AGREE: { value: 18, name: "同意退款" },
  REFUSE: { value: 19, name: "拒绝退款" },
  REFUNDARBITRATION: { value: 20, name: "退款仲裁" },
  ARBITRATION: { value: 21, name: "仲裁" },
  PROCESSED: { value: 22, name: "仲裁已处理" },
  REFUND_SUCCESS: { value: 23, name: "退款成功" },
  REFUND_FAIL: { value: 24, name: "退款失败" },
  CANCEL: { value: 25, name: "取消退款" },
  ARBITRATION_CANCEL: { value: 26, name: "取消仲裁" },
  INSERVICE: { value: 27, name: "服务中" },
  CAN_ASSIGN: { value: 28, name: "可指派" },
  NOT_ARRIVAL: { value: 29, name: "未到货" },
  SETTLED: { value: 30, name: "已结算" },
  UNSETTLED: { value: 31, name: "未结算" },
  CANCELED: { value: 32, name: "已取消" },
  CAN_COMPLAINT: { value: 33, name: "可投诉" },
  ASSIGN_OVERTIME: { value: 34, name: "指派超时订单" },
  WAIT_EVALUATE: { value: 35, name: "待评价" },
  WORKER_DAY_ORDER: { value: 36, name: "师傅日期统计订单状态" },
};

export const LOGISTICS_TYPE = {
  "1": "揽收",
  "0": "在途",
  "5": "派件",
  "3": "签收",
  "6": "退回",
  "4": "退签",
  "7": "转投",
  "2": "疑难",
  "8": "清关",
  "14": "拒签",
};


export const FOLLOW_TYPE = [
  {
    value: "NOT_FOLLOW_UP",
    label: "不跟进",
  },
  {
    value: "FOLLOWING_UP",
    label: "跟进中",
  },
  {
    value: "PROCESSED",
    label: "已处理",
  },
];
export const AD_CODE = [
  { name: "中华人民共和国", adcode: "100000" },
  { name: "北京市", adcode: "110000" },
  { name: "天津市", adcode: "120000" },
  { name: "河北省", adcode: "130000" },
  { name: "山西省", adcode: "140000" },
  { name: "内蒙古自治区", adcode: "150000" },
  { name: "辽宁省", adcode: "210000" },
  { name: "吉林省", adcode: "220000" },
  { name: "黑龙江省", adcode: "230000" },
  { name: "上海市", adcode: "310000" },
  { name: "江苏省", adcode: "320000" },
  { name: "浙江省", adcode: "330000" },
  { name: "安徽省", adcode: "340000" },
  { name: "福建省", adcode: "350000" },
  { name: "江西省", adcode: "360000" },
  { name: "山东省", adcode: "370000" },
  { name: "河南省", adcode: "410000" },
  { name: "湖北省", adcode: "420000" },
  { name: "湖南省", adcode: "430000" },
  { name: "广东省", adcode: "440000" },
  { name: "广西壮族自治区", adcode: "450000" },
  { name: "海南省", adcode: "460000" },
  { name: "重庆市", adcode: "500000" },
  { name: "四川省", adcode: "510000" },
  { name: "贵州省", adcode: "520000" },
  { name: "云南省", adcode: "530000" },
  { name: "西藏自治区", adcode: "540000" },
  { name: "陕西省", adcode: "610000" },
  { name: "甘肃省", adcode: "620000" },
  { name: "青海省", adcode: "630000" },
  { name: "宁夏回族自治区", adcode: "640000" },
  { name: "新疆维吾尔自治区", adcode: "650000" },
  { name: "台湾省", adcode: "710000" },
  { name: "香港特别行政区", adcode: "810000" },
  { name: "澳门特别行政区", adcode: "820000" },
];
